<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="6" :md="24">
          <el-form-item label="部门:" prop="deptList" v-if="getUserInfo.deptName === '办公室'">
            <el-select filterable v-model="form.deptId" placeholder="请选择部门" clearable>
              <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :md="24">
          <el-form-item label="姓名:" prop="userId" v-if="getUserInfo.deptName === '办公室'">
            <el-select filterable v-model="form.userId" placeholder="请选择姓名" clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="时间:" prop="date">
            <el-date-picker :clearable="false" v-model="form.date" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="异常类型:" prop="type" clearable>
            <el-select filterable v-model="form.type" placeholder="请选择" clearable>
              <el-option label="迟到" value="迟到" />
              <el-option label="缺卡" value="缺卡" />
              <el-option label="早退" value="早退" />
              <el-option label="缺勤" value="缺勤" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :md="24" class="action" style="margin-bottom:20px">
          <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
          <download-excel style="margin-left:20px" class="export-excel-wrapper" :data="json_data" :fields="json_fields"
            type="xls" worksheet="My Worksheet" :name="form.type ? form.type + '统计' : '考勤异常汇总'">
            <el-button size="small">导出</el-button>
          </download-excel>
        </el-col>
      </el-row>
    </el-form>
    <PTable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template #type="record">
        <span style="color:red"> {{ record.row.type }}</span>
      </template>
      <template #total="record">
        <span style="color:red"> {{ record.row.total }}</span>
      </template>
    </PTable>
  </div>
</template>
    
<script>
import PTable from '@/components/PTable';
import { Attendance } from '@/api/attendance'
import dayjs from 'dayjs'
export default {
  components: {
    PTable
  },
  data() {
    return {
      // 导出
      json_fields: {},
      json_data: [],
      form: {
        deptId: '',
        userId: '',
        date: [new Date(), new Date()],
        type: ''
      },
      columns: [
        {
          label: '基本信息',
          width: 200,
          children: [
            {
              label: '序号',
              scopedSlots: 'sn',
              width: 100,
              fixed: "left"
            }, {
              label: '姓名',
              prop: 'name',
              width: 100
            },
            {
              label: '部门',
              prop: 'deptName',
              width: 150
            }
          ]
        },
        {
          label: '异常汇总',
          children: [{ label: '异常合计', scopedSlots: 'total' }, { label: '迟到', prop: 'lateCount' }, { label: '缺卡', prop: 'lackCardCount' }, { label: '早退', prop: 'earlyLeaveCount' }, { label: '缺勤', prop: 'absenceCount' }]
        }
      ],
      columnsList: {
        '汇总': [{ label: '异常合计', scopedSlots: 'total' }, { label: '迟到', prop: 'lateCount' }, { label: '缺卡', prop: 'lackCardCount' }, { label: '早退', prop: 'earlyLeaveCount' }, { label: '缺勤', prop: 'absenceCount' }],
        '迟到': [{ label: '种类', scopedSlots: 'type' }, { label: '上班迟到', prop: 'realDutyTime' }, { label: '时长(分钟)', prop: 'lateTimes' }, { label: '备注', prop: 'remark' }],
        '缺卡': [{ label: '种类', scopedSlots: 'type' }, { label: '时间', prop: 'date' }, { label: '未打卡时间', prop: 'time' }, { label: '备注', prop: 'remark' }],
        '早退': [{ label: '种类', scopedSlots: 'type' }, { label: '早退时间', prop: 'realOffTime' }, { label: '时长(分钟)', prop: 'earlyOffWork' }, { label: '备注', prop: 'remark' }],
        '缺勤': [{ label: '种类', scopedSlots: 'type' }, { label: '缺勤时间', prop: 'date' }, { label: '', prop: 'date' }, { label: '时长(天)', prop: 'absenceTimes' }, { label: '备注', prop: 'remark' }],  //由于合并表头导致表头与表格错位
      },
      loadData: (pageParam) => {
        this.flag = false
        if (this.form.type === '迟到') {
          this.json_fields = {
            '姓名': 'name', //常规字段
            '部门名称': 'deptName', //支持嵌套属性
            '种类': 'type',
            '上班迟到': 'realDutyTime',
            '时长(分钟)': 'lateTimes',
            '备注': 'remark'
          }
        } else if (this.form.type === '缺卡') {
          this.json_fields = {
            '姓名': 'name', //常规字段
            '部门名称': 'deptName', //支持嵌套属性
            '种类': 'type',
            '时间': 'date',
            '未打卡时间': 'time',
            '备注': 'remark'
          }
        } else if (this.form.type === '早退') {
          this.json_fields = {
            '姓名': 'name', //常规字段
            '部门名称': 'deptName', //支持嵌套属性
            '种类': 'type',
            '早退时间': 'realOffTime',
            '时长(分钟)': 'earlyOffWork',
            '备注': 'remark'
          }
        } else if (this.form.type === '缺勤') {
          this.json_fields = {
            '姓名': 'name', //常规字段
            '部门名称': 'deptName', //支持嵌套属性
            '种类': 'type',
            '缺勤时间(开始)': 'date',
            '缺勤时间(结束)': 'date',
            '时长(天)': 'absenceTimes',
            '备注': 'remark'
          }
        } else {
          this.json_fields = {
            '姓名': 'name', //常规字段
            '部门名称': 'deptName', //支持嵌套属性
            '异常合计': 'total',
            '迟到': 'lateCount',
            '缺卡': 'lackCardCount',
            '早退': 'earlyLeaveCount',
            '缺勤': 'absenceCount'
          }
        }
        const startDate = dayjs(this.form.date[0]).format('YYYY-MM-DD')
        const endDate = dayjs(this.form.date[1]).format('YYYY-MM-DD')
        const data = {
          startDate,
          endDate,
          pageParam,
          userId: this.getUserInfo.deptName === '办公室' ?  this.form.userId : this.getUserInfo.userId,
          deptId: this.form.deptId,
          exType: this.form.type
        }
        if (!this.form.type) {
          
        return Attendance.getAbnormalAttend(this, data).then(res => {
          res.data.dataList.forEach(item => {
            item.total =  item.lateCount + item.lackCardCount + item.earlyLeaveCount + item.absenceCount
          })
          this.json_data = res.data.dataList
          return res
        })
        } else {
          return Attendance.getAttendanceState(this, data).then(res => {
          res.data.dataList.forEach(item => {
            if (this.form.type === '缺勤') item.absenceTimes = 1
            if (this.form.type === '缺卡') {
              let str = ''
              if (!item.realDutyTime) {
                str = '上班(08:30)'
              }
              if (!item.realOffTime) {
                str += ' 下班(17:00)'
              }
              item.time = str
            }
             item.type = this.form.type
          })
          this.json_data = res.data.dataList
          return res
        })
          
        }
      },
      userList: [],
      deptList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      Attendance.gitDict(this, { dictId: '1440944417170001920' }).then(res => {
        this.userList = res.data
      })
      Attendance.gitDict(this, { dictId: '1630757245237071872' }).then(res => {
        this.deptList = res.data
      })
    },
    submitForm(flag = true) {
      if (this.form.type) {
        this.columns[1].children = this.columnsList[this.form.type]
      } else {
        this.columns[1].children = this.columnsList['汇总']
      }
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    resetForm() {
      this.form = {
        deptName: '',
        name: '',
        date: [],
        type: ''
      }
      this.$refs.table.refresh(true)
    }
  }
}
</script>
    
<style lang="scss" scoped>
.action {
  display: flex;
}
</style>
    